import {
  getPoolFromToken,
  PoolByToken,
} from "@nitro-ape/shared/features/pools/api/get-pool-from-token";
import { isServer } from "@tanstack/react-query";
import { createFileRoute, Navigate, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/token/$tokenId")({
  component: TokenPage,
  loader: async ({ params }) => {
    const { tokenId } = params;

    let pool: PoolByToken | null = null;

    try {
      pool = await getPoolFromToken({ tokenId });
    } catch {
      pool = null;
    }

    if (isServer) {
      if (pool) {
        throw redirect({
          to: "/trade/$chain/$address",
          params: {
            chain: pool.chain,
            address: pool.poolId,
          },
        });
      } else {
        throw redirect({
          to: "/explore",
          search: {
            error: "pair-not-found",
          },
        });
      }
    }

    return { pool };
  },
});

function TokenPage() {
  const { pool } = Route.useLoaderData();

  if (pool) {
    return (
      <Navigate
        to="/trade/$chain/$address"
        params={{
          chain: pool.chain,
          address: pool.poolId,
        }}
      />
    );
  } else {
    return (
      <Navigate
        to="/explore"
        search={{
          error: "pair-not-found",
        }}
      />
    );
  }
}
